"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _autoGenCrumb = _interopRequireDefault(require("./auto-gen-crumb"));

var _clickTrackingCrumb = _interopRequireDefault(require("./click-tracking-crumb"));

var _optionsContext = require("./options-context");

var _jsxFileName = "/home/circleci/project/src/components/Breadcrumb.js";

var Breadcrumb = function Breadcrumb(props) {
  var _React$useContext = _react.default.useContext(_optionsContext.OptionsContext),
      useAutoGen = _React$useContext.useAutoGen;

  return useAutoGen ? _react.default.createElement(_autoGenCrumb.default, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: this
  })) : _react.default.createElement(_clickTrackingCrumb.default, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }));
};

var _default = Breadcrumb;
exports.default = _default;